import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SchoolService {

  constructor(
    private http: HttpClient,
  ) { }

  // SCHOOL CONTENT API
  getSchoolContents(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/admin/school-contents', { withCredentials: true });
  }

  createSchoolContrent(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + `api/v1/admin/school-contents`, JSON.stringify(item), { withCredentials: true });
  }

  updateSchoolContrent(item: any, schoolId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/school-contents/${schoolId}`, JSON.stringify(item), { withCredentials: true });
  }

  // SCHOOL SETTINGS API
  getSchoolSettings(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/admin/school-settings', { withCredentials: true });
  }

  createSchoolSettings(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/school-settings', JSON.stringify(item), { withCredentials: true });
  }

  updateSchoolSettings(item: any, schoolSettingsId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/school-settings/${schoolSettingsId}`, JSON.stringify(item), { withCredentials: true });
  }

  // SCHOOL YEAR API
  getSchoolYears(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/school-years', { withCredentials: true });
  }

  createSchoolYaer(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/school-years', JSON.stringify(item), { withCredentials: true });
  }

  updateSchoolYear(item: any, schoolYearId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/school-years/${schoolYearId}`, JSON.stringify(item), { withCredentials: true });
  }

  // SCHOOL YEAR TERMS API
  getSchoolYearTerms(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/school-year-terms', { withCredentials: true });
  }

  createSchoolYearTerms(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/school-year-terms', JSON.stringify(item), { withCredentials: true });
  }

  updateSchoolYearTerms(item: any, schoolYearTermId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/school-year-terms/${schoolYearTermId}`, JSON.stringify(item), { withCredentials: true });
  }

  // SCHOOL YEAR PERIOS API
  getSchoolYearPeriods(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/admin/school-year-periods', { withCredentials: true });
  }

  createSchoolYearPeriod(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/school-year-periods', JSON.stringify(item), { withCredentials: true });
  }

  updateSchoolYearPeriod(item: any, schoolYearPeriodId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/school-year-periods/${schoolYearPeriodId}`, JSON.stringify(item), { withCredentials: true });
  }

  // SCHOOL YEAR EVENTS API
  getSchoolYearEvents(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/admin/school-year-events', { withCredentials: true });
  }

  createSchoolYearEvent(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + 'api/v1/admin/school-year-events', JSON.stringify(item), { withCredentials: true });
  }

  updateSchoolYearEvent(item: any, schoolYearEventId): Observable<any> {
    return this.http
      .put<any>(environment.apiUrl + `api/v1/admin/school-year-events/${schoolYearEventId}`, JSON.stringify(item), { withCredentials: true });
  }

  // PROGRAMS API
  getFormPrograms(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/forms/programs', { withCredentials: true });
  }

  // PROFESSOR API
  getProfessorList(): Observable<any> {
    return this.http
      .get<any>(environment.apiUrl + 'api/v1/admin/professor/list', { withCredentials: true });
  }
}
